import {IComplianceItemData} from "./api";
import {environment} from "../../environments/environment";

/**
 * Parses HTML links from new_splink field and populates sp_links array for each compliance item
 */
export function parseComplianceSpLinks(complianceItems: IComplianceItemData[]): IComplianceItemData[] {
    for (const elm of complianceItems) {
        elm.sp_links = [];

        if (elm.new_splink == null) continue;

        const div = document.createElement('div');
        div.innerHTML = elm.new_splink;

        div.querySelectorAll('a').forEach(a => {
            const nameValue = elm['_new_nameid_value@OData.Community.Display.V1.FormattedValue'].replace(/ /g, '%20');
            const complianceName = elm.new_name.replace(/ /g, '%20');
            const complianceId = elm.new_complianceid.replace(/-/g, '');
            const fileName = encodeURIComponent(a.text).replace(/ /g, '%20');

            elm.sp_links.push({
                file_sp_link: a.href,
                file_src_link: `${environment.sharePointBaseUrl}${nameValue}/new_compliance/${complianceName}_${complianceId}/${fileName}`,
                file_name: a.text
            });
        });
    }

    return complianceItems;
}